/// <reference path="../../../../../../../typings/index.d.ts" />


// Used as an attribute on inputs so that when enter is hit soft keyboards on phones and tablets will disappear
module Meevo.Components.Controls.HideInput {

    import ICultureModel = Meevo.Components.Common.ICultureModel;
    import CultureSettings = Meevo.Components.Common.CultureSettings;

    class HidePhoneComponent implements angular.IComponentController {
        public static $inject = [
            '$scope',
            'meevo.AppSettings',
        ];

        name: string;
        selectedCulture: ICultureModel;
        model: ng.INgModelController;
        mhiOptions: { cultureModel: ICultureModel };

        get phone(): IPhoneModelValue {
            return this._phone;
        }

        set phone(value: IPhoneModelValue) {
            this._phone = value;

            this.model.$setViewValue(value);
        }

        private _phone: IPhoneModelValue;

        constructor(protected $scope: ng.IScope,
                    protected appSettings: Meevo.Components.Common.IAppSettings) {
            this.selectedCulture = CultureSettings.getByProperty('locale', appSettings.APP_COUNTRYID);
            this._phone = {
                countryCode: this.selectedCulture.countryCode,
                phoneNumber: ''
            };
            this.mhiOptions = {
                cultureModel: this.selectedCulture
            };
        }

        $onInit(): void {
            this.$scope.$watch(() => this.selectedCulture, (newValue: ICultureModel) => {
                this.mhiOptions.cultureModel = newValue;
            });
            this.$scope.$watch(() => this.model.$viewValue, (newValue: IPhoneModelValue) => {
                if (newValue.phoneNumber === this.phone.phoneNumber && newValue.countryCode === this.phone.countryCode) return;

                if (!this.selectedCulture) {
                    this.selectedCulture = CultureSettings.getByProperty('countryCode', newValue.countryCode);
                }

                if (this.selectedCulture.countryCode !== newValue.countryCode) {
                    this.selectedCulture = CultureSettings.getByProperty('countryCode', newValue.countryCode);
                }

                this.phone = newValue;
            }, true);
        }
    }

    angular
        .module('meevo.components.controls.HideInput')
        .component('hidePhone', <ng.IComponentOptions>{
            templateUrl: 'app/components/controls/hideInput/components/hide-phone/hide.phone.component.html',
            require: {
                model: 'ngModel'
            },
            bindings: {
                name: '@',
            },
            controller: HidePhoneComponent
        });
}
